import { useEffect } from 'react';

const TEXT_REPLACEMENTS: Record<string, string> = {
  Experience: 'Education',
  Honor管理: 'Education管理',
  添加Honor: '添加Education',
  编辑Honor: '编辑Education',
  Experience管理: 'Service管理',
  添加Experience: '添加Service',
  编辑Experience: '编辑Service',
  个人简介: '近期动态',
};

const PLACEHOLDER_REPLACEMENTS: Record<string, string> = {
  请输入个人简介: '请输入近期动态',
};

function replaceAdminText() {
  const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);
  const textNodes: Text[] = [];

  while (walker.nextNode()) {
    textNodes.push(walker.currentNode as Text);
  }

  textNodes.forEach((node) => {
    const currentText = node.nodeValue?.trim();
    if (!currentText) return;

    const replacement = TEXT_REPLACEMENTS[currentText];
    if (replacement && node.nodeValue) {
      node.nodeValue = node.nodeValue.replace(currentText, replacement);
    }
  });
}

function replaceAdminPlaceholders() {
  document.querySelectorAll<HTMLInputElement | HTMLTextAreaElement>('input[placeholder], textarea[placeholder]').forEach((field) => {
    const replacement = PLACEHOLDER_REPLACEMENTS[field.placeholder];
    if (replacement) {
      field.placeholder = replacement;
    }
  });
}

function clearInput(input: HTMLInputElement) {
  if (!input.value) return;

  const valueSetter = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value')?.set;
  valueSetter?.call(input, '');
  input.dispatchEvent(new Event('input', { bubbles: true }));
  input.dispatchEvent(new Event('change', { bubbles: true }));
}

function hideEducationDateSummary() {
  const educationHeading = Array.from(document.querySelectorAll('h2')).find(
    (heading) => heading.textContent?.trim() === 'Education管理',
  );

  const educationCard = educationHeading?.parentElement?.parentElement;
  if (!educationCard) return;

  Array.from(educationCard.querySelectorAll('p')).forEach((paragraph) => {
    const text = paragraph.textContent?.trim() || '';
    if (/^\d{4}-\d{2}\s*-\s*\d{4}-\d{2}$/.test(text)) {
      paragraph.style.display = 'none';
    }
  });
}

function hideEducationDateFields() {
  const educationModalTitle = Array.from(document.querySelectorAll('h2, h3')).find(
    (heading) => heading.textContent?.trim() === '编辑Education',
  );

  if (!educationModalTitle) return;

  const modalRoot = educationModalTitle.closest('[class*="fixed"]') || document.body;
  const dateLabels = Array.from(modalRoot.querySelectorAll('label')).filter((label) => {
    const text = label.textContent?.trim();
    return text === '开始时间' || text === '结束时间';
  });

  dateLabels.forEach((label) => {
    const input = label.querySelector('input');
    if (input instanceof HTMLInputElement) {
      clearInput(input);
    }

    const pairedGrid = label.closest('.grid');
    if (pairedGrid) {
      (pairedGrid as HTMLElement).style.display = 'none';
    } else {
      (label as HTMLElement).style.display = 'none';
    }
  });
}

function cleanAdminEducationUi() {
  if (!window.location.pathname.startsWith('/admin')) return;

  replaceAdminText();
  replaceAdminPlaceholders();
  hideEducationDateSummary();
  hideEducationDateFields();
}

export default function AdminEducationCleanup() {
  useEffect(() => {
    let frameId = 0;
    const scheduleCleanup = () => {
      window.cancelAnimationFrame(frameId);
      frameId = window.requestAnimationFrame(cleanAdminEducationUi);
    };

    scheduleCleanup();
    const observer = new MutationObserver(scheduleCleanup);
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });

    return () => {
      window.cancelAnimationFrame(frameId);
      observer.disconnect();
    };
  }, []);

  return null;
}
